import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateDarkModeUseCase {
    invoke: (itemId: number, data: any) => Promise<boolean>;
  }
  
  export class UpdateDarkMode implements UpdateDarkModeUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(itemId: number, data: any){
       
        if(!itemId){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateDarkMode(itemId, data);
        return update;
    }
  }